import { store } from "../store/store";
import { getQlikApp } from "./qlikService";
import { getQlikResources } from "./getQlikResources";
import { setQlikObject } from "../store/slice/qlikObjectSlice";
import { showSnackbar } from "../store/slice/snackbarSlice";
import { CYBER_CONFIG } from "../constants/cyberConfig";

const dispatch = store.dispatch;

async function readObjectData(appName: string, vizName: string, vizObject: any): Promise<any> {
  const vizObjectLayout = await vizObject.getLayout();
  const vizObjectFreshLayout = JSON.parse(JSON.stringify(vizObjectLayout)); //Workaround to avoid error on qlik/api when dispatching the object
  dispatch(setQlikObject({ appName, name: vizName, object: vizObjectFreshLayout }));
  return vizObjectLayout
}

export async function getObject(name: string, readLayout: boolean = true, id?: string, isObjectForLegend: boolean = false): Promise<any | null> {
  try {
    
    const vizConfig = await getQlikResources("qlik-visualizations")
    const vizDef = vizConfig[name];

    const qlikApp = await getQlikApp(vizDef.appRef);
    
    if (qlikApp) {
      //Define soft patch properties for changing object properties
      const propertyValues = 
        isObjectForLegend ? 
          {
            showTitles: false,
            legend: { show: false }
          }
          :
          {
            showTitles: false
          };
      const patches = Object.entries(propertyValues).map(([propertyName, value]) => ({
          qOp: 'replace',
          qPath: `/${propertyName}`,
          qValue: JSON.stringify(value)
      }));

      const vizObject = id ? await qlikApp.getObject(id) : await qlikApp.getObject(vizDef.id);
      await vizObject.applyPatches(patches, true);
      
      if(readLayout) {
        const vizObjectLayout = await readObjectData(vizDef.appRef, name, vizObject);
        
        //Handling new selections applied
        vizObject.on('changed', async () => {
          await readObjectData(vizDef.appRef, name, vizObject);
        });
        return vizObjectLayout
      }
      else {
        return vizObject;
      }

    }
  } catch (error) {
    console.error(`Error getting object for object: ${name}`, error);
    dispatch(showSnackbar({ reason: "error", message: CYBER_CONFIG.generalErrorMessage }));
  }

  return null;
}


export default {
    getObject
};